import { ApiResponse } from 'apisauce';
import { Api } from './api';

export type InboxItem = {
  inbox_last_message: {
    contact_id: string;
    bot_id: string;
    sent_by: string | null;
    campaign: string | null;
    type: 'text' | string;
    is_paid: boolean;
    reject_reason: string | null;
    direction: number;
    status: number;
    edited_by: string | null;
    created_at: string; // ISO date string
    id: string;
    data: {
      text: {
        body: string;
      };
      id: string;
      timestamp: number;
      type: 'text' | string;
      from: number;
      to: number | null;
      errors: any;
      referral: any;
      context: any;
      identity: any;
      message_id: string;
    };
    price_cbp: number | null;
  };
  inbox_unread: number;
  contact: {
    status: number;
    type: number;
    bot_id: string;
    channel_data: {
      phone: number;
      name: string;
      photo: string | null;
    };
    is_chat_opened: boolean;
    last_session: string | null;
    last_referral_at: string | null;
    last_referral: string | null;
    tags: string[];
    variables: Record<string, any>;
    operator: string | null;
    referral_source: string | null;
    last_activity_at: string;
    automation_paused_until: string | null;
    unsubscribed_at: string | null;
    is_banned: boolean;
    created_at: string;
    last_sessions: {
      service: {
        id: string;
        is_fake: boolean;
        is_expiration_timestamp_autogenerated: boolean;
        created_at: string;
        origin: {
          type: string;
        };
        expiration_timestamp: number;
      };
    };
    id: string;
  };
};

export type MessageItem = {
  bot_id: string;
  campaign: string | null;
  chain?: string | null;
  channel?: string | null;
  contact_id: string;
  created_at: string; // ISO date string
  data: {
    context: any | null; // TODO: define context type
    errors?: any | null; // TODO: define errors type
    from?: number;
    id?: string;
    identity?: any | null; // TODO: define identity type
    message_id: string;
    preview_url?: boolean;
    referral?: any | null; // TODO: define referral type
    text?: {
      body: string;
      preview_url?: boolean;
    };
    image?: {
      caption?: string;
      filename?: string;
      id: string;
      mime_type: string;
      sha256: string;
      url: string;
    };
    video?: {
      caption?: string;
      filename?: string;
      id: string;
      mime_type: string;
      sha256: string;
      url: string;
    };
    audio?: {
      filename?: string;
      id: string;
      mime_type: string;
      sha256: string;
      url: string;
    };
    document?: {
      caption?: string;
      filename?: string;
      id: string;
      mime_type: string;
      sha256: string;
      url: string;
    };
    timestamp?: number;
    to?: number | null;
    type: 'text' | string; // TODO: expand this type to include other message types
  };
  direction: number;
  edited_by: string | null;
  id: string;
  is_paid: boolean;
  price_cbp: number | null;
  reject_reason: string | null;
  sent_by: {
    avatar: string | null;
    email: string | null;
    firstname: string | null;
    id: string | number;
    lastname: string | null;
  } | null;
  status: number;
  type: 'text' | string; // TODO: expand this type to include other message types
};

type Channel = 'whatsapp' | 'telegram';

export class ChatApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  async getChats(
    channel: Channel = 'whatsapp'
  ): Promise<InboxItem[] | undefined> {
    const response: ApiResponse<InboxItem[]> = await this.api.apisauce.get(
      `${channel}/chats`
    );
    if (!response.ok) {
      throw response.originalError;
    }
    return response.data;
  }

  async getChatMessagesByContactId({
    channel = 'whatsapp',
    contactId
  }: {
    channel?: Channel;
    contactId: string;
  }): Promise<MessageItem[] | undefined> {
    const response: ApiResponse<MessageItem[]> = await this.api.apisauce.get(
      `${channel}/chat/${contactId}`
    );
    if (!response.ok) {
      throw response.originalError;
    }
    return response.data;
  }
}
